import React, { useEffect, useState } from 'react'
import styled from 'styled-components';

const ExcutiveReferal = () => {
  const[referal,setReferal] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    const data = localStorage.getItem('excutiveLogin')
    const parsedate = JSON.parse(data)
    setReferal(parsedate.bdeCode)
    if(parsedate.bdeCode){
        setLoading(false);
    }
  },[])

  const handleRefer = () => {
    const trimmed = phoneNumber.trim();

    // Validate Indian mobile number
    if (!/^[6-9]\d{9}$/.test(trimmed)) {
      alert('Please enter a valid 10-digit Indian mobile number.');
      return;
    }

    if (!referal) {
      alert('User data not loaded yet. Please try again.');
      return;
    }

    const fullNumber = `91${trimmed}`;

    // Merchant referral link
    const message = encodeURIComponent(
      `Hey! Check out this amazing platform https://bakpoket.com/executiveSignup/${referal}. Join using my referral!`
    );

    window.open(`https://wa.me/${fullNumber}?text=${message}`, '_blank');
  };

  return (
    <Container1>
      <InnerBox>
        <h5>Refer an Excutive via WhatsApp</h5>
        <Input
          type="tel"
          placeholder="Enter 10-digit mobile number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(-10))}
        />
        <Button onClick={handleRefer} disabled={!referal || loading}>
          {loading ? 'Loading...' : 'Send Referral'}
        </Button>
      </InnerBox>
    </Container1>
  )
}

export default ExcutiveReferal



const Container1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
  background-color:#fff;
  width:fit-content;
  border-radius:20px;
`;

const InnerBox = styled.div`
  width: 100%;
  max-width: 400px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  font-size: 16px;
  margin: 12px 0;
  border: 1px solid #ccc;
  border-radius: 8px;
  @media (max-width: 576px) {
    padding: 7px;
    font-size: 11px;
    margin: 6px 0;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 12px 20px;
  font-size: 16px;
  background-color: #25d366;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: #1ebd5a;
  }

  &:disabled {
    background-color: #a6a6a6;
    cursor: not-allowed;
  }

  @media (max-width: 576px) {
    padding: 7px 10px;
    font-size: 10px;
  }
`;